"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Icon_1 = __importDefault(require("./Icon"));
function DoubleFiletIcon(props) {
    return (react_1.default.createElement(Icon_1.default, Object.assign({}, props),
        react_1.default.createElement("path", { d: "M16.625,4.761H9.7A2.359,2.359,0,0,0,7.318,7.092V20.425A2.359,2.359,0,0,0,9.7,22.756h8.981a2.36,2.36,0,0,0,2.382-2.331V9.161Zm2.056,16.3H9.7a.659.659,0,0,1-.682-.632V7.092A.66.66,0,0,1,9.7,6.46h6.021V9.153a.813.813,0,0,0,.813.813h2.829V20.425A.659.659,0,0,1,18.681,21.057Z" }),
        react_1.default.createElement("path", { d: "M4.637,16.908V3.575a.659.659,0,0,1,.682-.632h7.425v-1.7H5.319A2.36,2.36,0,0,0,2.937,3.575V16.908a2.36,2.36,0,0,0,2.382,2.331h.85v-1.7h-.85A.66.66,0,0,1,4.637,16.908Z" })));
}
exports.default = DoubleFiletIcon;
